import { Box, Container, Typography, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useState } from "react";
import LuxuryPopup from "./LuxuryPopup";


const SalesCTA = () => {
  const [open, setOpen] = useState(false);

const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false);
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/charminar-hyderabad.webp")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "460px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      {/* 🔵 LUXURY BLUE OVERLAY */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `
            linear-gradient(
              135deg,
              rgba(15,99,165,0.65),
              rgba(15,99,165,0.55)
            )
          `,
        }}
      />

      {/* ✨ GLOSS LIGHT */}
      <Box
        sx={{
          position: "absolute",
          top: "-30%",
          left: "-10%",
          width: "700px",
          height: "700px",
          background:
            "radial-gradient(circle, rgba(255,255,255,0.25), transparent 60%)",
          filter: "blur(5px)",
        }}
      />

      {/* ✨ GLASS LAYER */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backdropFilter: "blur(2px)",
          background: "rgba(255,255,255,0.04)",
        }}
      />

      {/* CONTENT */}
      <Container sx={{ position: "relative", zIndex: 2 }}>

        {/* WHITE LINE */}
        <Box
          sx={{
            width: 70,
            height: 3,
            margin: "0 auto 22px",
            borderRadius: "10px",
            background: "rgba(255,255,255,0.8)",
          }}
        />

        {/* HEADING */}
        <Typography
        variant="h4"
          sx={{
          
            fontSize: { xs: 32, md: 48 },
            color: "#ffffff",
            fontWeight: 600,
            mb: 2,
          }}
        >
          Build a Sales System That Delivers Results

        </Typography>

        {/* DESCRIPTION */}
        <Typography
          sx={{
            fontSize: 17,
            color: "rgba(255,255,255,0.9)",
            // maxWidth: 60,
            margin: "0 auto",
            mb: 1,
            lineHeight: 1.7,
          }}
        >
          If your project isn’t converting the way it should, the problem isn’t demand, it’s the system behind it.
        </Typography>
        <Typography
          sx={{
            fontSize: 17,
            color: "rgba(255,255,255,0.9)",
            maxWidth: 640,
            margin: "0 auto",
            mb: 5,
            lineHeight: 1.7,
          }}
        >
          Let’s identify what’s missing, fix it, and build a structure that drives consistent, predictable sales.

        </Typography>

        {/* 💎 LUXURY BUTTON */}
        <Button
          onClick={handleOpen}
        endIcon={<ArrowForwardIcon />}
          sx={{
            px: 5,
            py: 1.7,
            borderRadius: "40px",
            fontWeight: 600,
            fontSize: 15,
            textTransform: "none",

            // 🔥 PREMIUM WHITE BUTTON
            background: "#ffffff",
            color: "#0f63a5",

            // 🔥 DEPTH SHADOW
            boxShadow: "0 15px 40px rgba(0,0,0,0.25)",

            transition: "all 0.3s ease",

            "&:hover": {
              background: "#f1f5f9",
              transform: "translateY(-3px)",
              boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
            },

            // 🔥 GLOSS EFFECT
            position: "relative",
            overflow: "hidden",

            "&::before": {
              content: '""',
              position: "absolute",
              top: "-50%",
              left: "-20%",
              width: "150%",
              height: "150%",
              // background:
              //   "radial-gradient(circle, rgba(255,255,255,0.7), transparent 60%)",
            },
          }}
        >
           Request Strategic Consultation

        </Button>

      </Container>
      <LuxuryPopup open={open} onClose={handleClose} />
    </Box>
  );
};

export default SalesCTA;